import script from "./FeatureArt.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureArt.vue?vue&type=script&setup=true&lang=js"

import "./FeatureArt.vue?vue&type=style&index=0&id=43aa6e58&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43aa6e58"]])

export default __exports__